const PRIMARY_STORAGE_KEY = 'sisfol_municipio_persist';
const LEGACY_STORAGE_KEY = 'municipioId';
const LEGACY_SHORTCUT_KEY = 'sisfol_atalho_antigo_recuperado';

export const isValidMunicipioId = (value) => /^[a-zA-Z0-9_-]{1,120}$/.test(String(value || '').trim());

export const getMunicipioIdFromUrl = (search = window.location.search) => {
  const value = new URLSearchParams(search).get('municipioId');
  return isValidMunicipioId(value) ? String(value).trim() : null;
};

export const getStoredMunicipioId = () => {
  const value = localStorage.getItem(PRIMARY_STORAGE_KEY) || localStorage.getItem(LEGACY_STORAGE_KEY);
  return isValidMunicipioId(value) ? String(value).trim() : null;
};

export const persistMunicipioId = (municipioId) => {
  if (!isValidMunicipioId(municipioId)) return false;
  localStorage.setItem(PRIMARY_STORAGE_KEY, municipioId);
  localStorage.setItem(LEGACY_STORAGE_KEY, municipioId);
  return true;
};

export const clearMunicipioId = () => {
  localStorage.removeItem(PRIMARY_STORAGE_KEY);
  localStorage.removeItem(LEGACY_STORAGE_KEY);
};

export const buildMunicipioLoginUrl = (municipioId, options = {}) => {
  if (!isValidMunicipioId(municipioId)) return null;
  const origin = options.origin || window.location.origin;
  const url = new URL('/login', origin);
  url.searchParams.set('municipioId', municipioId);
  if (options.source) url.searchParams.set('source', options.source);
  if (options.installMode) url.searchParams.set('install_mode', 'true');
  return url.toString();
};

export const buildMunicipioInstallUrl = (municipioId, options = {}) => {
  if (!isValidMunicipioId(municipioId)) return null;
  const origin = options.origin || window.location.origin;
  const url = new URL('/instalar', origin);
  url.searchParams.set('municipioId', municipioId);
  return url.toString();
};

export const resolveMunicipioContext = ({ search = window.location.search, sessionMunicipioId = null } = {}) => {
  const searchParams = new URLSearchParams(search);
  const urlMunicipioId = getMunicipioIdFromUrl(search);
  const storedMunicipioId = getStoredMunicipioId();
  const validSessionMunicipioId = isValidMunicipioId(sessionMunicipioId) ? sessionMunicipioId : null;

  if (searchParams.has('municipioId') && !urlMunicipioId) {
    return { municipioId: null, source: 'invalid-url', conflict: false, recoveredLegacyShortcut: false };
  }

  if (urlMunicipioId) {
    return {
      municipioId: urlMunicipioId,
      source: 'url',
      conflict: Boolean(validSessionMunicipioId && validSessionMunicipioId !== urlMunicipioId),
      recoveredLegacyShortcut: false,
    };
  }

  if (validSessionMunicipioId) {
    return { municipioId: validSessionMunicipioId, source: 'session', conflict: false, recoveredLegacyShortcut: false };
  }

  if (storedMunicipioId) {
    sessionStorage.setItem(LEGACY_SHORTCUT_KEY, 'true');
    return { municipioId: storedMunicipioId, source: 'storage', conflict: false, recoveredLegacyShortcut: true };
  }

  return { municipioId: null, source: 'missing', conflict: false, recoveredLegacyShortcut: false };
};

export const wasLegacyShortcutRecovered = () => sessionStorage.getItem(LEGACY_SHORTCUT_KEY) === 'true';

export const isLocalDevelopmentHost = (hostname = window.location.hostname) => {
  const normalized = String(hostname || '').trim().toLowerCase();
  return normalized === 'localhost'
    || normalized === '127.0.0.1'
    || normalized === '::1'
    || normalized === '[::1]';
};

export const shouldCanonicalizeLegacyShortcut = ({ source, pathname = window.location.pathname } = {}) => (
  source === 'storage' && ['/', '/login'].includes(String(pathname || '/'))
);

export const updateMunicipalManifestLink = (municipioId) => {
  const current = document.querySelector('link[rel="manifest"]');
  if (!current) return;
  current.href = isValidMunicipioId(municipioId) && !isLocalDevelopmentHost()
    ? `/manifest/${encodeURIComponent(municipioId)}.webmanifest`
    : '/manifest.json';
};

export const isStandaloneDisplayMode = () => (
  window.matchMedia?.('(display-mode: standalone)').matches
  || window.navigator.standalone === true
  || document.referrer.includes('android-app://')
);
